import React, { useState } from "react";
import classes from "./Impact.module.css";
import Modal from "../../ReusableComponents/Modal/Modal";

const ImpactCard = ({ title, content, image, index }) => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <article className={classes.impactCard} data-card>
      <div className={classes.media}>
        <div className={classes.mediaFrame}>
          <img src={image} alt="" className={classes.mediaImg} loading="lazy" />
          <span className={classes.mediaWash} aria-hidden="true" />
        </div>

        {/* Numeral tile in the slot the date tile occupies on an article card,
            so the two card types share a silhouette. */}
        <span className={classes.indexTile} aria-hidden="true">
          {String(index + 1).padStart(2, "0")}
        </span>
      </div>

      <div className={classes.cardBody}>
        <h3 className={classes.impactHeading}>{title}</h3>
        <span className={classes.titleRule} aria-hidden="true" />
        <p className={classes.impactDesc}>{content}</p>
      </div>

      <footer className={classes.cardFoot}>
        <span className={classes.footLabel}>Impact</span>
        <button
          type="button"
          className={classes.learnMoreBtn}
          onClick={() => setShowPopup(true)}
        >
          <span className={classes.learnMoreText}>Learn more</span>
          <span className={classes.learnMoreDisc} aria-hidden="true">
            <svg viewBox="0 0 16 16">
              <path
                d="M3 8h9M8.5 4l4 4-4 4"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </button>
      </footer>

      {showPopup && (
        <Modal title={title} image={image} onClose={() => setShowPopup(false)}>
          <p>{content}</p>
        </Modal>
      )}
    </article>
  );
};

export default ImpactCard;
